import React, { FC } from 'react';

import { MainContainerProps } from '../types/props';
import { Dialog } from './Dialog';
import { ErrorDisplay } from './ErrorDisplay';
import { Header } from './Header';
import { HeaderDetails as HeaderDetailsComponent } from './HeaderDetails';
import { Snackbar } from './Snackbar';

export const MainContainer: FC<MainContainerProps> = ({
	HeaderDetails = HeaderDetailsComponent,
	headerDetails,
	headerTitle,
	navLinks,
	showDialog,
	setShowDialog,
	showSnackbar,
	setShowSnackbar,
	error,
	pathname,
	children,
}) => (
	<div id='pca__main-container'>
		<Header
			title={headerTitle}
			navLinks={navLinks}
			HeaderDetails={(props: any) => <HeaderDetails {...props} headerDetails={headerDetails} />}
			pathname={pathname}
		/>
		<main id='pca__main-content'>
			<div id='pca__main-body'>
				{children}
				<Dialog showDialog={showDialog} setShowDialog={setShowDialog} />
				{error ? <ErrorDisplay error={error} /> : null}
				<Snackbar showSnackbar={showSnackbar} setShowSnackbar={setShowSnackbar} />
			</div>
		</main>
	</div>
);
